import { makeAuthService } from '../../auth/auth-service-factory';
import { makeLogService } from '../log/log/log-service-factory';
import { IEntityOptionsService } from './entity-options-service';
import { EntityOptionsServiceImpl } from './entity-options-service-impl';

let entityOptionsService: IEntityOptionsService;

export function makeEntityOptionsService(): IEntityOptionsService {
  if (!entityOptionsService) {
    entityOptionsService = new EntityOptionsServiceImpl(
      makeLogService(),
      makeAuthService(),
    );
  }

  return entityOptionsService;
}
